export default {
    /**
     * @func verifiedToken
     * @desc Mutation that is committed when the user's cookie tokens have been successfully verified.
     */
    verifiedToken(state, auth) {
        // Cache account information
        state.name = auth.name
        state.email = auth.email

        localStorage.setItem('auth', state.id = auth.id)
        localStorage.setItem('authenticated', state.authenticated = true)
        localStorage.setItem('verified', state.verified = Date.now())
        localStorage.setItem('jwtToken', state.jwt = auth.jwt)
    },

    /**
     * @func verifiedToken
     * @desc Mutation that is committed when the user's cookie tokens have been successfully verified.
     */
    verifiedJWT(state, payload) {
        localStorage.setItem('auth', state.id = payload.id)
        localStorage.setItem('authenticated', state.authenticated = true)
        localStorage.setItem('verified', state.verified = Date.now())
    },

    /**
     * @func unverifiedToken
     * @desc Mutation that is committed when the user's cookie tokens could not be verified.
     */
    unverifiedToken(state) {
        state.id = null
        state.name = null
        state.email = null

        state.authenticated = false
        localStorage.removeItem('auth')
        localStorage.removeItem('verified')
        localStorage.removeItem('jwtToken')
    },

    /**
     * @func receivedToken
     * @desc Mutation committed when the user successfully logs in or resets their account, and receives an access token.
     */
    receivedToken(state, token) {
        localStorage.setItem('auth', state.id = token.payload.id)
        localStorage.setItem('authenticated', state.authenticated = true)
        localStorage.setItem('verified', state.verified = Date.now())
        localStorage.setItem('jwtToken', state.jwt = token.jwt)
    },

    /**
     * @func invalidatedToken
     * @desc Mutation when the user invalidates
     */
    invalidatedToken(state) {
        state.id = null
        state.name = null
        state.email = null

        state.authenticated = false
        localStorage.removeItem('auth')
        localStorage.removeItem('verified')
        localStorage.removeItem('authenticated')
        localStorage.removeItem('provider')
        localStorage.removeItem('jwtToken')
    },

    validatedEmail(state, email) {
        state.email = email
    },

    validatedCode(state, code) {
        state.code = code
    },

    validatedDoctor(state, doctor) {
        state.doctor = doctor
    },

    validatedUpgradeToken(state, response) {
        state.upgradeToken = response.upgrade_token
        state.doctor = response.doctor
    },

    validatedResetToken(state, token) {
        state.resetToken = token
    },

    validatedInviteToken(state, response) {
        state.id = response.auth
        state.inviteToken = response.invite_token
        state.doctor = response.provider
    },
    failedValidation(state) {
        state.failedValidation = true
    },
    /**
     * @func initiatedLogin
     * @desc The user initiated the login flow, so the state records this as the current user's email,
     *       and stores the light user flag.
     */
    initiatedLogin(state, auth) {
        state.email = auth.email
        state.type = auth.type
    },

    initiatedJoin(state, auth) {
        state.email = auth.email
        state.name = auth.name
        state.code = auth.code
        state.doctor = auth.doctor
    },

    initiatedReset(state, auth) {
        state.email = auth.email
    },

    setAutoLogout(state, setValue) {
        state.autoLogout = setValue
    },

    /**
     * @func startedAuthentication
     * @desc When the user initiates an authentication/verification/reset request
     */
    startedAuthentication(state) {
        state.authenticating = true
    },

    /**
     * @func finishedAuthentication
     * @desc When the user completes an authentication request
     */
    finishedAuthentication(state) {
        state.authenticating = false
    }
}
